import { accessKey, userServiceUrl } from "../config/config";

const login = async (userCredentials) => {
    try {
      console.log('user Service Url:', userServiceUrl);
      const response = await fetch(`${userServiceUrl}/login`, { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': accessKey,
        },
        body: JSON.stringify(userCredentials)
      });
      if (!response.ok) {
        throw new Error('Request failed');
      }
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw new Error(error.message);
    }
};

const initiateRegisterUser = async (newUserData) => {
  try {
    const response = await fetch(`${userServiceUrl}/register/initiate`, { 
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': accessKey,
      },
      body: JSON.stringify(newUserData)
    });
    if (response.status === 409) {
      const error = new Error('An account with that email already exists');
      error.code = response.status;
      throw error;
    }
    if (!response.ok) {
      throw new Error('Request failed');
    }
    const responseData = await response.clone().json();
    return responseData;
  } catch (error) {
    throw error;
  }
};

const verifyRegisterUser = async (newUserData) => {
  try {
    const response = await fetch(`${userServiceUrl}/register/verify`, { 
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': accessKey,
      },
      body: JSON.stringify(newUserData)
    });
    if (!response.ok) {
      throw new Error('Request failed');
    }
    const responseData = await response.clone().json();
    return responseData;
  } catch (error) {
    throw error;
  }
};

const registerUser = async (newUserData) => {
  try {
    const response = await fetch(`${userServiceUrl}/register`, { 
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': accessKey,
      },
      body: JSON.stringify(newUserData)
    });
    if (!response.ok) {
      throw new Error('Request failed');
    }
    const responseData = await response.clone().json();
    return responseData;
  } catch (error) {
    throw new Error(error.message);
  }
};

const getCustomerInformation = async (customerId, authToken) => {
  try {
    const response = await fetch(`${userServiceUrl}/user/customer/${customerId}`, { 
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`, // Add the Bearer token to the header
      }
    });
    if (!response.ok) {
      throw new Error('Request failed');
    }
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    throw new Error(error.message);
  }
};

const updateProfile = async (user, authToken) => {
  try {
    const response = await fetch(`${userServiceUrl}/user`, { 
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`, // Add the Bearer token to the header
      },
      body: JSON.stringify(user)
    });
    if (!response.ok) {
      throw new Error('Request failed');
    }
    const responseData = await response.clone().json();
    return responseData;
  } catch (error) {
    throw new Error(error.message);
  }
};

const forgotPassword = async (email) => {
  try {
    const response = await fetch(`${userServiceUrl}/user/forgot-password`, { 
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': accessKey,
      },
      body: JSON.stringify({ email: email })
    });
    if (!response.ok) {
      throw new Error('Request failed');
    }
    const responseData = await response.clone().json();
    return responseData;
  } catch (error) {
    throw new Error(error.message);
  }
};

const resetPassword = async (resetData) => {
  try {
    const response = await fetch(`${userServiceUrl}/user/reset-password`, { 
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': accessKey,
      },
      body: JSON.stringify(resetData)
    });
    if (!response.ok) {
      throw new Error('Request failed');
    }
    const responseData = await response.clone().json();
    return responseData;
  } catch (error) {
    throw new Error(error.message);
  }
};

export {
  login,
  initiateRegisterUser,
  verifyRegisterUser,
  registerUser,
  getCustomerInformation,
  updateProfile,
  forgotPassword,
  resetPassword,
};